// extracted by css-extract-rspack-plugin
var _1 = "gbLIJ7u7T9Es3sUm";
var _2 = "qaW8zAQzsgAOQKSw";
var _3 = "gbLIJ7u7T9Es3sUm";
var _4 = "qaW8zAQzsgAOQKSw";
var _5 = "Gg46gkvfWCwAd7Xk";
var _6 = "bKLPRSIRRGsZ2zzH";
var _7 = "lDvPUoM4efg3ZQjd";
export { _1 as "button-next", _2 as "button-prev", _3 as "buttonNext", _4 as "buttonPrev", _5 as "slide", _6 as "slider", _7 as "wrapper" }
